module.exports = __webpack_public_path__ + "img/couples-086.d5cdf4fa.jpg";